<template>
    <div>
      <h5 class="product-sub-title mb-4">Pilihan Warna</h5>
  
      <div class="d-flex justify-content-center align-items-center mb-3 bg-white" style="height: 400px;">
        <img
          :src="colors[selectedIndex].color"
          alt="selected-motor"
          style="max-height: 100%; max-width: 80%; object-fit: contain"
        />
      </div>
  
      <div class="col">
        <div class="row">
          <div
            v-for="(color, idx) in colors"
            :key="idx"
            class="col-6 col-md-3 mb-3"
            :style="{ opacity: selectedIndex === idx ? 1 : 0.3 }"
            @click="selectColor(idx)"
          >
            <div class="color-box text-center">
              <div
                class="color-image-wrapper mb-2"
                style="height: 100px; display: flex; justify-content: center; align-items: center; background: #fff;"
              >
                <img
                  :src="color.color"
                  alt="Warna Motor"
                  style="max-height: 100%; max-width: 80%; object-fit: contain"
                />
              </div>
              <p class="product-description" style="color: #13346c">
                {{ color.label }}
              </p>
            </div>
          </div>
        </div>
        <p class="product-description">
          *Untuk ketersediaan varian warna motor bisa langsung di komunikasikan dengan Costumer Service [NAMA BPRS ANDA]
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "MotorColorSelector",
    props: {
      colors: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        selectedIndex: 0
      };
    },
    methods: {
      selectColor(index) {
        this.selectedIndex = index;
        this.$emit("color-selected", this.colors[index]);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Tambahkan style tambahan jika diperlukan */
  </style>


// WEBPACK FOOTER //
// src/components/MotorColorSelector.vue